import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCommunitiesAdminSettingsProps = {
  id: number;
};

export const keyCommunitiesAdminSettings: BaseKeyFunction<
  KeyCommunitiesAdminSettingsProps
> = ({ id }) => ["communities-admin-settings", id.toString()];
